<script>
  import { api } from '../../store'
  let localapi
  api.subscribe((value) => {
    localapi = value
  })
  let firstName, lastName, mobile, subject
  let mainaddress = 'rock'

  function validateForm() {
    let allValue = {
      firstName,
      lastName,
      mobile,
      subject,
      mainaddress,
    }

    let error = ''

    for (const [key, value] of Object.entries(allValue)) {
      if (value === undefined) {
        error += `${key}\n`
        console.log(key)
      }
    }

    error == ''
      ? senddata(allValue)
      : alert(`Please fill the folowing fields \n${error}`)
  }

  let senddata = async (param) => {
    if (mainaddress != 'rock') {
      alert('Oops, Somthing went wrong, Try later')
    } else {
      let data = new FormData()
      data.append('firstName', param.firstName)
      data.append('lastName', param.lastame)
      data.append('mobile', param.mobile)
      data.append('subject', param.subject)

      let xhttp = new XMLHttpRequest()

      // xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          // Typical action to be performed when the document is ready:
          let result = JSON.parse(xhttp.responseText)
          console.log(result)

          if (result.error == false) {
            alert('Oops, Somthing went wrong, Try later2')
          } else {
            alert('Message Send')
            firstName = ''
            lastName = ''
            mobile = ''
            subject = ''
          }
        }
      }
      xhttp.open('POST', `${localapi}?url=sendMail`, true)
      xhttp.send(data)
    }
  }
</script>

<br />
<div class="container">
  <h1 style="">Contact Us</h1>
  <form on:submit|preventDefault="{validateForm}">
    <label for="fname">First Name</label>
    <input
      bind:value="{firstName}"
      type="text"
      id="fname"
      name="firstname"
      placeholder="Your name.." />
    <label for="lname">Last Name</label>
    <input
      bind:value="{lastName}"
      type="text"
      id="lname"
      name="lastname"
      placeholder="Your last name.." />
    <label for="mob">Mobile Number</label>
    <input
      bind:value="{mobile}"
      type="text"
      id="mob"
      placeholder="YourMobile Number.." />
    <input
      class="d-none"
      bind:value="{mainaddress}"
      type="text"
      id="mob"
      placeholder="Your Main Address" />

    <label for="subject">Subject</label>
    <textarea
      bind:value="{subject}"
      id="subject"
      name="subject"
      placeholder="Write something.."
      style="height:170px"></textarea>
    <input class="" type="submit" value="Submit" />
  </form>
</div>

<style>
  * {
    box-sizing: border-box;
  }

  input[type='submit'] {
    display: block;
    margin-left: auto;
  }
  /* Style inputs */
  input[type='text'],
  textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
  }

  input[type='submit'] {
    background-color: #ff9933;
    color: white;
    padding: 12px 20px;
    border: none;
    cursor: pointer;
  }

  input[type='submit']:hover {
    background-color: rgb(233, 116, 0);
  }

  /* Style the container/contact section */
  .container {
    border-radius: 5px;
    background-color: #f2f2f2;
    padding: 10px;
  }

  /* Create two columns that float next to eachother */
  .column {
    float: left;
    width: 50%;
    margin-top: 6px;
    padding: 20px;
  }

  /* Clear floats after the columns */
  .row:after {
    content: '';
    display: table;
    clear: both;
  }

  /* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
  @media screen and (max-width: 600px) {
    .column,
    input[type='submit'] {
      width: 100%;
      margin-top: 0;
    }
  }
</style>
